import Error404 from '../components/ErrorComponents/Error404';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import type { NextPage } from 'next';

const Error404Page: NextPage = () => {
    return <Error404 />;
};

export default withAuthenticationRequired(Error404Page);
